import { CUSTOM_ACTIONS_VERSION, handleApiError } from '@/lib/utils'
import type { AccountVesselV3 } from '@geckoal/gecko-api-client'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useApi } from '../api'

export const useVesselStore = defineStore('vessel', () => {
    const vessel = ref<AccountVesselV3 | undefined>()
    const loadingVessel = ref<boolean>(false)

    const sharedVesselInfo = computed(() => {
        return vessel.value?.sharedVesselInfo
    })

    async function loadVessel(accountId: number, vesselId: number, forceLoad = false, forceGeoUpdate = false) {
        if (!forceLoad && vessel.value?.accountId === accountId && vessel.value?.vesselId === vesselId) return // caching, TODO: may want to check a load time here

        await handleApiError(
            async () => {
                loadingVessel.value = true
                vessel.value = undefined
                vessel.value = await useApi().getAccountVesselDetailsV5({
                    accountId,
                    vesselId,
                    includeInvalidReadings: 'true',
                    forceGeoUpdate,
                    customActionsVersion: CUSTOM_ACTIONS_VERSION
                })
            },
            async () => {
                loadingVessel.value = false
            }
        )
    }

    return { vessel, loadingVessel, loadVessel, sharedVesselInfo }
})
